import React from "react"
import SaleStage from "../components/SaleStage"
class Step3SS extends React.Component {
    render() {

        const { client, updateClient } = this.props;
        const { officialSales={} } = (client && client.stages_of_sale) || {};

        const {
            isSpa,
            spa,
            completePdcs,
            signedContractToSellFile,
            signedContractToSellDate,
            isCompleted,
            completionDate,
            others=[]
        } = officialSales;

        const step3Fields = [
            { key: 'isSpa', type: 'toggle', label: 'SPA / Without SPA', value: isSpa},
            { key: 'spa', type: 'file', label: 'SPA', value: spa},
            { key: 'completePdcs', type: 'toggle', label: 'Complete PDCs', value: completePdcs},
            { key: 'signedContractToSellFile', type: 'file', label: 'Signed Contract To Sell File', value: signedContractToSellFile},
            { key: 'signedContractToSellDate', type: 'date', label: 'Signed Contract To Sell Date', value: signedContractToSellDate},
        ]

        return (
            !!client ? <SaleStage 
                title="Official Sales"
                fields={step3Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="officialSales"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step3SS
